import Icon from "./Icon";
import * as React from "react";
class Step extends React.Component {
    render() {
        const { description, index, state, title } = this.props;
        return (React.createElement("div", { className: `steps-step ${state}` },
            React.createElement("div", { className: "steps-step-number" }, state === "done" ? React.createElement(Icon, { name: "feedback-success" }) : index + 1),
            React.createElement("div", { className: "steps-step-main" },
                React.createElement("div", { className: "steps-step-title" }, title))));
    }
}
export default Step;
